import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-unidades-list',
  templateUrl: './unidades-list.component.html',
  styleUrls: ['./unidades-list.component.scss'],
})
export class UnidadesListComponent {
  constructor(private sanitizer: DomSanitizer) {}

  unidades = [
    {
      nome: 'COPE BOA VISTA',
      endereco: 'Avenida Conde da Boa Vista, 1512, Boa Vista, Recife - PE',
      cep: '50060-001',
      contatos: [{ numero: '(81) 3081-5999', tipo: 'ligacao' }],
    },
    {
      nome: 'COPE IMPERATRIZ',
      endereco: 'Rua Imperatriz Tereza Cristina, 131, Boa Vista, Recife - PE',
      cep: '50060-120',
      contatos: [{ numero: '(81) 99779-2777', tipo: 'whatsapp' }],
    },
    {
      nome: 'COPE OLINDA',
      endereco: 'Avenida Getúlio Vargas, 1162, Bairro Novo, Olinda - PE',
      cep: '53030-010',
      contatos: [{ numero: '(81) 98214-3880', tipo: 'whatsapp' }],
    },
    {
      nome: 'COPE CAMARAGIBE',
      endereco: 'Avenida Belmiro Correia, 3128, Timbí, Camaragibe - PE',
      cep: '54759-000',
      contatos: [
        { numero: '(81) 3458-1969', tipo: 'ligacao' },
        { numero: '(81) 98208-5881', tipo: 'whatsapp' },
      ],
    },
    {
      nome: 'COPE IBURA',
      endereco: 'Avenida Dois Rios, 704, Ibura, Recife - PE',
      cep: '51230-322',
      contatos: [{ numero: '(81) 97114-8676', tipo: 'whatsapp' }],
    },
    {
      nome: 'HOSPITAL CASA FORTE',
      endereco: 'Rua Edson Álvares, 370, Casa Forte, Recife - PE',
      cep: '52061-450',
      contatos: [{ numero: '(81) 99413-8889', tipo: 'whatsapp' }],
    },
  ];

  gerarMapa(endereco: string): SafeResourceUrl {
    const url = `https://www.google.com/maps?q=${encodeURIComponent(endereco)}&output=embed`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  abrirWhatsapp(numero: string) {
    const numeroLimpo = numero.replace(/\D/g, '');
    window.open(`https://wa.me/55${numeroLimpo}`, '_blank');
  }
  
  ligar(numero: string) {
    const numeroLimpo = numero.replace(/\D/g, '');
    window.open(`tel:+55${numeroLimpo}`, '_self');
  }
}
